import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const ONBOARDING_STEPS_COMPLETED = gql(`
  query onboardingStepsCompleted {
    me {
      __typename
      id
      onboardingStepsCompleted {
        __typename
        CreatedApp
        UploadedCode
        InvitedUser
        CreatedSubscriptionOffer
      }
    }
  }
`);

export function useOnboardingStepsCompleted() {
  const { data, ...rest } = useQuery(ONBOARDING_STEPS_COMPLETED, {
    fetchPolicy: "cache-and-network"
  });

  const onboardingStepsCompleted = data?.me.onboardingStepsCompleted;

  // 1 step is added to each value to account for 'Sign up' step
  const numberOfSteps = data
    ? Object.keys(data.me.onboardingStepsCompleted).filter(
        (k) => k !== "__typename"
      ).length + 1
    : 1;
  const numberOfStepsCompleted = data
    ? Object.values(data.me.onboardingStepsCompleted).filter(
        (v) => v && v !== onboardingStepsCompleted?.__typename
      ).length + 1
    : 1;
  const completedPercentage = data
    ? (numberOfStepsCompleted / numberOfSteps) * 100
    : 0;

  return {
    data: onboardingStepsCompleted,
    numberOfStepsCompleted,
    completedPercentage,
    isOnboardingCompleted: completedPercentage === 100,
    ...rest
  };
}
